import { render, staticRenderFns } from "./Tiers.vue?vue&type=template&id=f61c18a4&scoped=true"
import script from "./Tiers.vue?vue&type=script&lang=js"
export * from "./Tiers.vue?vue&type=script&lang=js"
import style0 from "./Tiers.vue?vue&type=style&index=0&id=f61c18a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61c18a4",
  null
  
)

export default component.exports